/* eslint-disable react-hooks/exhaustive-deps */
import { Alert } from '@mui/material'
import MatAppBar from '../MatAppBar/MatAppBar'
import { useState, useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import { makeStyles, createStyles } from '@mui/styles'
import { setShouldRender } from '../ProgressOverlay/store/actionCreator'
import { setRedirectedWorkOderList } from '../WorkOrderList/WorkOrderListStore/actionCreator'
import { setAssignments } from '../WorkOrderList/WorkOrderListStore/actionCreator'
import CacheListManager from '../CacheListManager/CacheListManager'
import {
  INPUT_PERFORMANCE_DELAY,
  SCHEDULE_OR_ASSIGNMENT,
  WORK_ORDER_FILTER_PROPERTIES,
  api,
} from '../../globalConstants'
import { fetchData } from '../../service/HttpService'
import { useAuth } from '@praxis/component-auth'
import StatusAlert from '../StatusAlert/StatusAlert'
import CommonCardList from '../CommonCardList/CommonCardList'
import { filterAssignmentsBy7Days } from '../../utils'
import useSearch from '../../utils/hooks/useSearch'

const useStyles = makeStyles((theme) =>
  createStyles({
    cardHeader: {
      background: theme.palette.grey[300],
    },
    actionIcon: {
      margin: theme.spacing(1, 0.5, 0, 0),
    },
    cardContent: {
      padding: theme.spacing(1),
    },
    warningError: {
      margin: theme.spacing(1),
    },
  }),
)

const RedirectedWorkOrders = ({
  redirectedWorkOrders,
  storeId,
  lastUpdated,
  setAssignments,
  setShouldRender,
  setRedirectedWorkOderList,
  toggle,
}) => {
  const classes = useStyles()
  const auth = useAuth()
  const userId = auth.session.userInfo.lanId?.toUpperCase()
  const URL_SEARCH_KEY = 'search'
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const { isDCUser } = useSelector((state) => ({
    ...state.userInfoReducer,
  }))

  const [filteredWorkOrders, onSearch] = useSearch(
    URL_SEARCH_KEY,
    redirectedWorkOrders || [],
    WORK_ORDER_FILTER_PROPERTIES(isDCUser),
    true,
    INPUT_PERFORMANCE_DELAY,
  )
  const redirectedWorkOrdersLength = redirectedWorkOrders.length
  const filteredWorkOrdersLength = filteredWorkOrders?.length

  useEffect(() => {
    return () => setRedirectedWorkOderList([])
  }, [])

  const getAssignments = async () => {
    try {
      setShouldRender(true, 'Loading...', SCHEDULE_OR_ASSIGNMENT(isDCUser))
      setLoading(true)
      setError(false)
      const response = await fetchData(api.myAssignments(storeId, userId))
      const assigmentsScheduledThisWeek = filterAssignmentsBy7Days(
        response.assignmentsdata,
      )
      setAssignments(assigmentsScheduledThisWeek)
    } catch (error) {
      setError(true)
    } finally {
      setLoading(false)
      setShouldRender(false)
    }
  }

  useEffect(() => {
    const getOpenWorkOrders = async () => {
      if (!redirectedWorkOrdersLength && !loading) {
        try {
          setShouldRender(true, 'Loading...', 'Redirected Work Orders')
          setLoading(true)
          setError(false)
          const response = await fetchData(api.openWorkOrders(storeId))
          setRedirectedWorkOderList(response.woDetails)
        } catch (error) {
          setError(true)
        } finally {
          setLoading(false)
          setShouldRender(false)
        }
      }
    }
    getOpenWorkOrders()
  }, [redirectedWorkOrdersLength])

  useEffect(() => {
    redirectedWorkOrdersLength && getAssignments()
  }, [toggle, redirectedWorkOrdersLength])

  const infoMessage = `${filteredWorkOrdersLength} / ${redirectedWorkOrdersLength} Redirected WO(s)`

  return (
    <>
      <MatAppBar
        arrowBack
        text="Redirected WO's"
        search={{
          onSearch: (input) => onSearch(input),
          searchKey: URL_SEARCH_KEY,
        }}
      />
      {!loading && !error && redirectedWorkOrdersLength > 0 && (
        <CacheListManager
          lastUpdated={lastUpdated}
          listLength={redirectedWorkOrders}
          clearMethod={() => setRedirectedWorkOderList([])}
        />
      )}

      {!filteredWorkOrdersLength && !loading && !error && (
        <Alert
          severity="warning"
          data-testid={'no-data-text'}
          className={classes.warningError}
        >
          There are no redirected work orders to display.
        </Alert>
      )}
      {error && !loading && (
        <Alert severity="error" className={classes.warningError}>
          Unable to connect to work orders service.
        </Alert>
      )}

      {filteredWorkOrders && !loading ? (
        <>
          {!error && <StatusAlert text={infoMessage} />}
          <CommonCardList
            listData={filteredWorkOrders}
            filteredWorkOrdersLength={filteredWorkOrdersLength}
          />
        </>
      ) : null}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    redirectedWorkOrders: state.workOrderListReducer.redirectedWorkOrders,
    storeId: state.storeInfoReducer.storeId,
    lastUpdated: state.workOrderListReducer.lastUpdated.redirectedWorkOrders,
    toggle: state.workOrderListReducer.toggle,
  }
}

const mapDispatchToProps = {
  setShouldRender,
  setRedirectedWorkOderList,
  setAssignments,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RedirectedWorkOrders)
